import React, { useContext, useEffect, useState } from 'react'
import UserContext from '../../../../contexts/UserContext'
import axios from '../../../../config/axios'
import {
  SelectInput,
  SelectOption,
} from './style'
import { headerAccessesTable, accessesTableRequiredFields } from '../utils'
import Validation from './validation'
import { useProfileContext } from '../../../../contexts/AccessesContext'
import { useSearchAccesses } from '../../../../contexts/SearchAccessesContext'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import TableFiltersContext from '../../../../contexts/TableFiltersContext'
import { GlobalTable, HeaderLine, Td, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import { useOutletContext } from 'react-router-dom'
import { PeopleOutletType } from '..'
import { TypeMainOutlet } from '../..'

interface user {
  id: number
  name: string
  email: string
  phone: string
  company: string
  status: number
  cnpj: string
  adminUser: boolean
  permissions: string[]
  approved: string
  profileId: number | null
}

const TableAccesses = () => {
  const { token, user } = useContext(UserContext)
  const [users, setUsers] = useState<user[]>([])
  const [updateUserData, setUpdateUserData] = useState(0)
  const { profiles, usersLoadQuantity, setUsersLoadQuantity, fetchProfilesWithoutAdmin } = useProfileContext()
  const { accessesFilters } = useContext(TableFiltersContext)
  const { setTabIndex } = useOutletContext<PeopleOutletType>()
  const { search } = useOutletContext<TypeMainOutlet>()
  const [hasMoreUsers, setHasMoreUsers] = useState(true)
  const [totalUsers, setTotalUsers] = useState<number | undefined>(undefined)

  useEffect(() => {
    setTabIndex(0)
  }, [])
  
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`, {
        params: {
          search,
          loadQuantity: usersLoadQuantity,
          filters: JSON.stringify(accessesFilters),
          excludeAdminProfile: 'true',
        }
      })
      .then((response) => {
        const resp = response.data
        const usersData = Array.isArray(resp) ? resp : resp.data || []
        const total = typeof resp === 'object' && typeof resp.total === 'number' ? resp.total : undefined

        let hasMoreData = false
        let dataToShow: any[] = usersData

        if (typeof total === 'number') {
          hasMoreData = usersData.length < total
          dataToShow = usersData
        } else {
          const legacyHasMore = usersData.length > usersLoadQuantity
          dataToShow = legacyHasMore ? usersData.slice(0, usersLoadQuantity) : usersData
          hasMoreData = legacyHasMore
        }

        setUsers(dataToShow)
        setHasMoreUsers(hasMoreData)
        setTotalUsers(total)
        console.log('👥 [ACCESSES] Loaded:', dataToShow.length, 'hasMore:', hasMoreData, 'total:', total)
      })
      .catch((error) => {
        console.log('Ocorreu um erro ao obter os dados dos users', error)
        setHasMoreUsers(false)
      })
    fetchProfilesWithoutAdmin()
  }, [updateUserData, search, usersLoadQuantity, accessesFilters])

  const updateProfileOfUser = async (
    idUser: number,
    idProfile: number | null,
  ) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/${idUser}`,
        { profileId: idProfile }
      )
      setUpdateUserData((prev) => prev + 1)
    } catch (error) {
      console.error('Erro ao atualizar o perfil do usuário', error)
    }
  }

  return (
    <>
      <GlobalTable>
        <tbody>
          <HeaderLine>
            {headerAccessesTable.map((header) => (
              <Th key={header}>{header}</Th>
            ))}
          </HeaderLine>
          {users.map((user: any) => (
            <Tr key={user.id}>
              {accessesTableRequiredFields.map((field, index) => (
                <Td key={index}>
                    {field === 'profileId' ? (
                      <SelectInput
                        value={user.profileId || 0}
                        onChange={(e) =>
                          updateProfileOfUser(
                            user.id,
                            Number(e.target.value) || null,
                          )
                        }
                      >
                        <SelectOption value={0}>
                          Usuário sem perfil
                        </SelectOption>
                        {profiles.map((profile) => (
                          <SelectOption key={profile.id} value={profile.id}>
                            {profile.name}
                          </SelectOption>
                        ))}
                      </SelectInput>
                    ) : (
                      <>
                        {['approved', 'blocked', 'pendent', 'pending'].includes(
                          user[field],
                        ) ? (
                          <Validation
                            situation={user[field]}
                            id={user.id}
                            onUpdate={() =>
                              setUpdateUserData((prev) => prev + 1)
                            }
                          />
                        ) : (
                          <>
                            {field === 'adminUser'
                              ? user.profileId === 3
                                ? 'Admin'
                                : 'Comum'
                              : user[field]}
                          </>
                        )}
                      </>
                    )}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
        <tfoot>
          <FooterTr>
            <Td colSpan={headerAccessesTable.length} style={{ textAlign: 'center', background: 'transparent' }}>
              <LoadMoreButton 
                currentCount={users.length} 
                totalCount={totalUsers} 
                onLoadMore={() => {
                  const newQuantity = usersLoadQuantity + 10
                  console.log('👥 [ACCESSES] Botão clicado - incrementando de', usersLoadQuantity, 'para', newQuantity)
                  console.log('👥 [ACCESSES] Estado:', { usersLength: users.length, totalUsers, hasMore: hasMoreUsers })
                  setUsersLoadQuantity(newQuantity)
                }} 
                hasMore={hasMoreUsers}
              />
            </Td>
          </FooterTr>
        </tfoot>
      </GlobalTable>
    </>
  )
}

export default TableAccesses

